export default __webpack_public_path__ + "static/Rhyme4-dc7a225ca43ba6b5c3a609c814b037ca.mp3";